<template>
  <div>
    <div class="row">
      <div class="col-12">
        <b-card header="Current Assignments" header-tag="h4" body-class="mb-3 record_card_body">
          <div class="row">
            <div class="col-12" style="min-height: 400px">
              <currentDatable :row-data="current_assignments" :loading-message="'Loading Current Assignments...'" :no-rows-message="'No Current Assignments Found'"
                              :columns="current_ass_columns" :type="'assignment'" :record-type="'assignment'" :heightStyle="heightStyle"></currentDatable>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-card header="Historic Assignments" header-tag="h4" body-class="mb-3 record_card_body">
          <div class="row">
            <div class="col-12" style="min-height: 400px">
              <historicDatable :row-data="historic_assignments" :loading-message="'Loading Historic Assignments...'" :no-rows-message="'No Historic Assignments Found'"
                               :columns="historic_ass_columns" :type="'assignment'" :record-type="'assignment'" :heightStyle="heightStyle"></historicDatable>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import currentDatable from 'datatables/assignments_datatable'
import historicDatable from 'datatables/assignments_datatable'

export default {
  name: "assignments",
  props: ['current_assignments', 'historic_assignments'],
  components: {
    currentDatable,
    historicDatable
  },
  data() {
    return {
      heightStyle: 'height: 400px !important',

      current_ass_columns: [
        {headerName: 'Assigned Date', minWidth: 150, valueGetter: this.h_assigned_date_vg},
        {headerName: 'Order Ref', minWidth: 110, field: 'order_job.order_ref'},
        {headerName: 'Worker Sage Ref', minWidth: 150, field: 'worker.sage_ref'},
        {headerName: 'Worker Name', minWidth: 150, field: 'worker.full_name'},
        {headerName: 'Job Title', minWidth: 150, field: 'order_job.rel_order_position.job_title'},
        {headerName: 'Pay Rate', minWidth: 100, valueGetter: this.h_pay_rate_vg},
        {headerName: 'Admin Rate', minWidth: 115, valueGetter: this.h_admin_rate_vg},
        {headerName: 'Start Date', minWidth: 115, valueGetter: this.h_start_date_vg},
        {headerName: 'End Date', minWidth: 115, valueGetter: this.h_end_date_vg},
        {headerName: 'Assigned By', minWidth: 150, field: 'user.name'},
        {headerName: 'Gang Leader', minWidth: 90, valueGetter: this.h_gang_leader_vg},
        {headerName: 'Part of Gang', minWidth: 95, valueGetter: this.h_part_of_gang_vg},
        {headerName: 'Gang Lead By', minWidth: 135, valueGetter: this.h_gang_lead_by_vg},
      ],
      historic_ass_columns: [
        {headerName: 'Assigned Date', minWidth: 150, valueGetter: this.h_assigned_date_vg},
        {headerName: 'Order Ref', minWidth: 110, field: 'order_job.order_ref'},
        {headerName: 'Worker Sage Ref', minWidth: 150, field: 'worker.sage_ref'},
        {headerName: 'Worker Name', minWidth: 150, field: 'worker.full_name'},
        {headerName: 'Job Title', minWidth: 150, field: 'order_job.rel_order_position.job_title'},
        {headerName: 'Pay Rate', minWidth: 100, valueGetter: this.h_pay_rate_vg},
        {headerName: 'Admin Rate', minWidth: 115, valueGetter: this.h_admin_rate_vg},
        {headerName: 'Start Date', minWidth: 115, valueGetter: this.h_start_date_vg},
        {headerName: 'End Date', minWidth: 115, valueGetter: this.h_end_date_vg},
        {headerName: 'Assigned By', minWidth: 150, field: 'user.name'},
        {headerName: 'Gang Leader', minWidth: 90, valueGetter: this.h_gang_leader_vg},
        {headerName: 'Part of Gang', minWidth: 95, valueGetter: this.h_part_of_gang_vg},
        {headerName: 'Gang Lead By', minWidth: 135, valueGetter: this.h_gang_lead_by_vg},
      ]
    }
  },
  methods: {
    // Value Getters
    h_assigned_date_vg(params) {
      return this.$options.filters.formatDateTime(params.data.created_at);
    },
    h_pay_rate_vg(params) {
      return this.$options.filters.currency(params.data.position_rate.pay_amount);
    },
    h_admin_rate_vg(params) {
      if (params.data.position_rate.admin_fee_type === '£ (pound)') {
        return this.$options.filters.currency(params.data.position_rate.admin_fee_amount);
      }
      else if (params.data.position_rate.admin_fee_type === '% (percentage)') {
        return this.$options.filters.percentage(params.data.position_rate.admin_fee_amount);
      }
    },
    h_start_date_vg(params) {
      return this.$options.filters.formatDate(params.data.start_date);
    },
    h_end_date_vg(params) {
      return this.$options.filters.formatDate(params.data.end_date);
    },
    h_gang_leader_vg(params) {
      return params.data.is_gang_leader ? 'Yes' : 'No';
    },
    h_part_of_gang_vg(params) {
      return params.data.gang_leader !== null ? 'Yes' : 'No';
    },
    h_gang_lead_by_vg(params) {
      return params.data.gang_leader !== null ? params.data.gang_leader.full_name : '';
    },
  }
}
</script>
